/**
 * Resolves the name of the user who performed an action.
 * Supports both the new hybrid object format and the old string format.
 * 
 * @param {string|object} auditField - The createdBy or updatedBy field from the database.
 * @param {Array} membersData - The list of agency members from the global state.
 * @returns {string} The resolved name or fallback.
 */
export const resolveAuditName = (auditField, membersData) => {
    
    // Handle null/undefined
    if (!auditField) return "Unknown";

    // Handle old string format
    if (typeof auditField === 'string') {
        return auditField;
    }

    // Handle new object format: { uid: string, name: string, email: string, timestamp: string }
    if (typeof auditField === 'object') {
        
        // 1. Try to find the user in the current members list (for latest info)
        if (auditField.uid && Array.isArray(membersData)) {
            const currentMember = membersData.find(m => m.uid === auditField.uid);
            if (currentMember?.name) {
                return currentMember.name;
            }
        }

        // 2. Fallback to the snapshot name recorded at the time of the action
        return auditField.name || auditField.email || "Unknown";
    }

    return "Unknown";
};
